define('views/modules/profile/edit/custom-message-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/user',
    // collections
    'collections/conversation/custom-messages',
    // views
    'views/parts/info-section',
    'views/parts/form/textbox',
    'views/parts/form/textarea-advanced',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/profile/edit/custom-message-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    User,
    // collections
    CCustomMessages,
    // views
    VInfoSection,
    VTextbox,
    VTextareaAdvanced,
    VChoices,
    // templates
    TCustomMessageEditForm
) {

    var VCustomMessageEditForm = Backbone.View.extend({
        template: TCustomMessageEditForm,

        regions: {
            root: '.custom-message-edit',
            titleInput: '.title-input',
            messageInput: '.message-input',
            defaultWelcomeMessageInput: '.default-welcome-message-input',
        },

        initialize: function(opt) {
            this.options = opt || {};

            // var model = this.model,
            //     collection = this.collection = new CCustomMessages(null, {});

            this.view = {
                info: new VInfoSection({
                    title: "Your custom messages",
                    // help: "messages:helpbox-contact-us",
                    content: this.template
                    //,model: this.model
                }),
                titleInput: new VTextbox({
                    label: 'conversation:Title',
                    labelposition: 'outer',
                    attribute: 'title',
                    model: this.model
                }),
                messageInput: new VTextareaAdvanced({
                    label: i18n.t('conversation:Enter your custom message'),
                    attribute: 'message',
                    labelposition: 'outer',
                    autosize: true,
                    height: "120px",
                    model: this.model,
                    toolbar: [
                        ['style', ['bold', 'italic', 'underline']],
                        ['insert', ['link']],
                        ['resizeButton', ['resizeButton']]
                    ],
                    buttons: {
                        resizeButton: this.createResizeButton(this)
                    }
                }),
                defaultWelcomeMessageInput: new VChoices({
                    label: 'conversation:default-welcome-message-label',
                    help: 'conversation:default-welcome-message-help',
                    model: this.model,
                    attribute: 'defaultWelcomeMessage'
                }),
            };

        },
        render: function() {
            this.assign(this.view.info, this.$el)
                .generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.titleInput, zone.$titleInput)
                .assign(view.messageInput, zone.$messageInput)
                .assign(view.defaultWelcomeMessageInput, zone.$defaultWelcomeMessageInput);

            return this;
        },

        createResizeButton: function(context) {
            var ui = Backbone.$.summernote.ui;

            var resizeButton = ui.button({
                className: 'resize',
                contents: '<i class="sl-icon-size-fullscreen"></i>',
                click: function(a,b,c) {
                    context.$el.find('.note-editable').toggleClass('large');
                    var $element = $(a.target)
                    if ($element.is('button')) {
                        $element = $element.find('i')
                    }
                    if (context.$el.find('.note-editable').hasClass('large')) {
                        $element.removeClass().addClass('sl-icon-size-actual');
                    } else {
                        $element.removeClass().addClass('sl-icon-size-fullscreen');
                    }
                }
            });

            return resizeButton.render();
        }

    });

    return VCustomMessageEditForm;
});

